// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"538":"recorder","983":"profiler"}[chunkId] + "." + {"538":"43936d21","983":"e13079cb"}[chunkId] + ".js";
};